module.exports = __webpack_public_path__ + "static/img/base3.99b6dfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chaye/base3.jpg
// module id = 1625
// module chunks = 2